import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AztecScannerAction} from '../../../../enums/next/aztec-scanner-action.enum';
import {NextAztecScannerService} from '../../../../services/next-aztec-scanner.service';
import {TranslationContainerComponent} from '../../../abstract/translation-container.component';

@Component({
  selector: 'app-next-aztec-scanner-scanner',
  templateUrl: './next-aztec-scanner-scanner.component.html',
  styleUrls: []
})
export class NextAztecScannerScannerComponent extends TranslationContainerComponent implements OnInit {

  @Output() action: EventEmitter<AztecScannerAction> = new EventEmitter<AztecScannerAction>();

  constructor(public aztecScannerService: NextAztecScannerService) {
    super('AZTEC_SCANNER.SCANNER');
  }

  ngOnInit(): void {
    this.aztecScannerService.initScanner();
  }

  cancel() {
    this.action.emit(AztecScannerAction.CANCEL_SCANNING);
    this.aztecScannerService.stopScanning();
  }

  mock(): void {
    this.aztecScannerService.mock();
  }

}
